(() => {
  function init(root=document) {
    root.querySelectorAll('.journey-colors:not([data-ready])').forEach(controls => {
      controls.dataset.ready='true';
      const hero=controls.closest('.journey-hero');
      let model=controls.dataset.model || 'sport';
      function show(button) {
        controls.querySelectorAll('[data-suit-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
        const image=model==='sport'?button.dataset.sportImage:button.dataset.kruvazeImage;
        hero.querySelectorAll('.journey-figure').forEach(figure=>figure.style.backgroundImage=`url("${image}")`);
        controls.querySelector('.journey-style-label').textContent=(model==='sport'?'İki düğmeli':'Kruvaze')+' · '+button.dataset.colorLabel;
      }
      controls.querySelectorAll('[data-suit-image]').forEach(button => {
        button.addEventListener('click',()=>show(button));
      });
      controls.querySelectorAll('[data-suit-model]').forEach(button=>button.addEventListener('click',()=>{
        model=button.dataset.suitModel;
        controls.querySelectorAll('[data-suit-model]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
        show(controls.querySelector('[data-suit-image][aria-pressed="true"]'));
      }));
      show(controls.querySelector('[data-suit-image][aria-pressed="true"]'));
    });
    root.querySelectorAll('.suit-edit:not([data-ready])').forEach(edit=>{
      edit.dataset.ready='true';
      edit.querySelectorAll('[data-edit-model]').forEach(button=>button.addEventListener('click',()=>{
        const model=button.dataset.editModel;
        edit.querySelectorAll('[data-edit-model]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
        edit.querySelectorAll('.color-edit-card').forEach(card=>{
          const portrait=card.querySelector('[data-edit-image]');
          portrait.style.backgroundImage=`url("${model==='sport'?portrait.dataset.sportImage:portrait.dataset.kruvazeImage}")`;
          const label=model==='sport'?'İki düğmeli sportif':'Kruvaze';
          portrait.setAttribute('aria-label',card.dataset.colorLabel+' '+label+' takım stil görseli');
          card.querySelector('[data-edit-description]').textContent=model==='sport'?'İki düğmeli · Sportif':'Kruvaze · Ceket ve pantolon';
          const link=card.querySelector('[data-edit-link]');
          card.querySelector('[data-sport-price]').hidden=model!=='sport';
          link.href=model==='sport'?link.dataset.sportUrl:link.dataset.kruvazeUrl;
          link.textContent='Takımı inceleyin ↗';
          const photoLink=card.querySelector('[data-edit-portrait-link]');
          photoLink.href=link.href;
          photoLink.setAttribute('aria-label',card.dataset.colorLabel+' '+label+' takımını inceleyin');
        });
      }));
    });
  }
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
